import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../../store'
import MintUI from 'mint-ui'
import { Lazyload } from 'mint-ui'
import 'mint-ui/lib/style.css'
import './permission' // permission control
import 'lib-flexible'

import uweb from 'vue-uweb'
Vue.use(uweb,'1278905460')

Vue.config.productionTip = false
Vue.use(MintUI)
Vue.use(Lazyload)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
